import Vue from 'vue'
import App from './App.vue'
import BootstrapVue from 'bootstrap-vue'
import router from './router'
import Breadcrumbs from './components/bread_crumbs'
import { store } from './store';
import VueFeather from 'vue-feather';
import VueSweetalert2 from 'vue-sweetalert2';
import Notifications from 'vue-notification';
import VueApexCharts from 'vue-apexcharts';
import Toasted from 'vue-toasted';
import FunctionalCalendar from 'vue-functional-calendar';
import VueCountryCode from "vue-country-code";

Vue.use(VueCountryCode);

import vSelect from 'vue-select';
Vue.component('v-select', vSelect)

import PxCard  from './components/Pxcard.vue'
Vue.component(PxCard.name, PxCard)

// vue select style
import 'vue-select/dist/vue-select.css';


// Import Theme scss
import './assets/scss/app.scss'


Vue.use(Notifications)
Vue.use(VueFeather);

Vue.use(Toasted,{
  iconPack: 'fontawesome'
});

Vue.use(BootstrapVue)
Vue.use(VueSweetalert2);
Vue.use(require('vue-chartist'))

Vue.component('apexchart', VueApexCharts)
Vue.use(FunctionalCalendar, {
  dayNames: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su']
});
Vue.component('Breadcrumbs', Breadcrumbs)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')